module.exports = __webpack_public_path__ + "img/small-3.06a7db93.jpg";